import PrzekazyWygenerowaneTable from "./table";

const PrzekazyWygenerowane = () => {
	return (
		<>
			<PrzekazyWygenerowaneTable />
		</>
	);
};

export default PrzekazyWygenerowane;
